<ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="model && model.level1">
  <li class="nav-item dropdown {{l1.cnf && l1.cnf.class?l1.cnf.class:''}}" *ngFor="let l1 of model.level1; let l1i=index">
    <!-- <span *ngIf="l1.cnf && l1.cnf.icon" class="{{l1.cnf.icon}}">xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</span> -->
    <a class="nav-link dropdown-toggle" href="#" id="{{l1.id}}" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{l1.tit}}</a>

    <!-- level 2 ------------>
    <ul class="dropdown-menu" [attr.aria-labelledby]="l1.id" id="L{{l1.id}}">
      <!-- <li><a class="dropdown-item disabled text-muted" href="#">داشبورد {{l1.tit}}</a></li> -->
      <div class="row" style="flex-wrap:initial">
        <ng-container *ngFor="let l2 of l1.level2; let l2i=index">
          <div class="col">
            <!-- <li class="text-warning">
          <span>{{l2.tit}}</span><hr class="dropdown-divider">
        </li> -->
            <!-- <div class="row navbar-vertical-label-wrapper mt-3 mb-2 {{l1.cnf && l1.cnf.class?l1.cnf.class:''}}"> -->
              <li style="display: ruby;">
                <img src="{{glob.host}}menu/ico/{{glob.config.theme}}/{{l2.id}}" (click)="glob.emode?service.ico_brows($event, l2.id):''; $event.stopPropagation();" class="menu_col_img">
              &nbsp;<span class="menu_col_title">{{l2.tit}}</span>
            </li>
              <!-- <div class="col-auto navbar-vertical-label" style="color:#5e6e82; font-size: 12px; margin-right: 0.5rem;"><span *ngIf="l1.cnf && l1.cnf.icon" class="{{l1.cnf.icon}}"></span> </div> -->
              <!-- <div class="col ps-0">
                <hr class="mb-0 navbar-vertical-divider" />
              </div> -->
            <!-- </div> -->
            

            <li *ngFor="let l3 of l2.level3; let l3i=index"><a class="dropdown-item" [routerLink]="this.glob.emode?[]:routa(l3)" (click)="service.tab_changer()" data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show">{{l3.tit}}
                <!-- <li class="nav-item" *ngFor="let l3 of l2.level3; let l3i=index"></li> -->
                <!-- <div class="d-flex align-items-center" [attr.class]="l2.cnf && l2.cnf.class?l2.cnf.class:null">
          <span *ngIf="l2.cnf && l2.cnf.icon" class="fs-1 {{l2.cnf.icon}}"></span>
          <span class="nav-link-text ps-1 bold fs-0">{{l2.tit}}</span>
        </div> -->
              </a>
            </li>
          </div>
        </ng-container>
      </div>
    </ul>
  </li>
</ul>
<input type="file" id="ico_menuid" style="display: none" (change)="service.ico_set($event)">